import CTNTable from '@ctn/ui/components/ctn-table';
import { useMemo } from 'react';

import { type Action, makeActions } from '@/helpers/table';
import { type ISujetoListado } from '@/interfaces/model/don.interface';

import { getColumns } from './columns';

type IntervinienteListadoProps = {
	readonly onEdit?: (data: ISujetoListado) => void;
	readonly onDelete?: (data: ISujetoListado) => void;
	readonly onSubsanar?: (data: ISujetoListado) => void;
	readonly onView?: (data: ISujetoListado) => void;
	readonly hasColumnSubsanacion?: boolean;
	readonly data: ISujetoListado[];
	readonly noData?: string;
};
const IntervinientesListado = ({
	onEdit,
	onDelete,
	onSubsanar,
	onView,
	data,
	noData,
	hasColumnSubsanacion,
}: IntervinienteListadoProps) => {
	const columns = useMemo(() => {
		const actions: Array<Action<ISujetoListado>> = [
			{
				width: 140,
				label: 'Editar',
				command: onEdit,
				hideIf: () => !onEdit,
			},
			{
				width: 110,
				label: 'Ver detalle',
				command: onView,
				hideIf: () => !onView,
			},
			{
				width: 100,
				label: 'Subsanar',
				command: onSubsanar,
				hideIf: ({ subsanacionPendiente }) => !subsanacionPendiente,
			},
			{ width: 100, label: 'Eliminar', command: onDelete, hideIf: () => !onDelete },
		];

		const columnsWithOutActions = getColumns({
			hasColumnSubsanacion,
		});

		const actionsColumn = makeActions<ISujetoListado>({ data, actions });
		
		return [...columnsWithOutActions, actionsColumn];
	}, [data, hasColumnSubsanacion]);

	return (
		<CTNTable
			idData="id"
			loading={false}
			loadingConf={{ spinner: true }}
			className="c-pnp-table"
			columns={columns}
			data={data}
			totalData={data.length}
			noDataConf={{ description: noData ?? 'Aún no has añadido ningún interviniente' }}
			pageSize={100}
		/>
	);
};

export default IntervinientesListado;
